import React, { useContext, useCallback, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../../context/AuthContext';

const Bottom = () => {
    const { logout } = useContext(AuthContext);
    const navigate = useNavigate();
    const [isVisible, setIsVisible] = useState(false);

    const handleLogout = useCallback((event) => {
        event.preventDefault();
        logout();
        navigate('/admin/system-login');
    }, [logout, navigate]);

    // Scroll to top functionality
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    useEffect(() => {
        const toggleVisibility = () => {
            const scrollTop = document.documentElement.scrollTop || document.body.scrollTop; // Mobile compatibility
            setIsVisible(scrollTop > 300);
        };

        window.addEventListener('scroll', toggleVisibility);
        return () => window.removeEventListener('scroll', toggleVisibility);
    }, []);

    return (
        <>
            {/* Logout Modal */}
            <div className="modal fade" id="logoutModal" tabIndex="-1" aria-labelledby="logoutModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="logoutModalLabel">Ready to Leave?</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            Select "Logout" below if you are ready to end your current session.
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary" type="button" data-bs-dismiss="modal">
                                Cancel
                            </button>
                            <button className="btn btn-primary" data-bs-dismiss="modal" onClick={handleLogout}>
                                Logout
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Scroll to Top Button */}
            <button
                onClick={scrollToTop}
                style={{
                    position: 'fixed',
                    bottom: '15px',
                    right: '15px',
                    width: '40px',
                    height: '40px',
                    backgroundColor: 'rgba(0, 123, 255, 0.8)',
                    border: '1px solid rgba(0, 123, 255, 0.9)',
                    borderRadius: '8px',
                    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
                    display: isVisible ? 'flex' : 'none', // Use inline styles for visibility
                    justifyContent: 'center',
                    alignItems: 'center',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease-in-out',
                    zIndex: 9999 // Increased for mobile
                }}
                onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(0, 123, 255, 1)'}
                onMouseLeave={(e) => e.target.style.backgroundColor = 'rgba(0, 123, 255, 0.8)'}
            >
                <i className="fas fa-angle-up" style={{ color: '#fff', fontSize: '18px' }}></i>
            </button>

        </>
    );
};

export default Bottom;
